import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-863fa75c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mainContainer" }

import { onMounted } from "vue";
import { useLocationsStore } from "@/stores/locations";
import { db } from "@/composables/firebase";
import {
  collection,
  query,
  startAfter,
  limit,
  getDocs,
  where,
} from "firebase/firestore";

import LocationOverview from "@/components/LocationOverview.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const locationsStore = useLocationsStore();

onMounted(async () => {
  if (!locationsStore.notQuery) {
    locationsStore.notQuery = true;
    getFirstPage();
  }
});

async function getFirstPage() {
  const first = query(
    collection(db, "locations"),
    where("approved", "==", false),
    limit(5)
  );

  const data = await getDocs(first);
  locationsStore.notApprovedLastDocSnapshot = data.docs[data.docs.length - 1];
  locationsStore.notApprovedStop = data.docs.length < 5;

  data.forEach((location) => {
    const locationData = location.data();
    locationData.id = location.id;
    locationsStore.locations.push(locationData);
  });
}

async function newLocations() {
  // add items to the list
  let newLocations: any = [];

  const next = query(
    collection(db, "locations"),
    where("approved", "==", false),
    startAfter(locationsStore.notApprovedLastDocSnapshot),
    limit(5)
  );

  const newData = await getDocs(next);
  locationsStore.notApprovedStop = newData.docs.length < 5;
  locationsStore.notApprovedLastDocSnapshot =
    newData.docs[newData.docs.length - 1];
  newData.forEach((location) => {
    const locationData = location.data();
    locationData.id = location.id;
    newLocations.push(locationData);
  });

  locationsStore.locations = [...locationsStore.locations, ...newLocations];
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(locationsStore).locations.filter(
        (location) => location.approved == false
      ), (location, index) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        to: `/location/${location.id}`,
        class: "location",
        key: index
      }, {
        default: _withCtx(() => [
          _createVNode(LocationOverview, { data: location }, null, 8, ["data"])
        ]),
        _: 2
      }, 1032, ["to"]))
    }), 128)),
    (!_unref(locationsStore).notApprovedStop)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          onClick: newLocations,
          class: "nextButton"
        }, " Next "))
      : _createCommentVNode("", true)
  ]))
}
}

})